import React from "react";
import "../../components/common/styles/expandedCard.css";
import "../../components/homepage/styles/works.css";

export const expandedCardBody = (
  <div className="works-body-expanded">
    <div className="only-work-stuff">
      <div className="work-expanded">
        <img src="./mg-logo.png" alt="Mean Guppy logo" className="work-image" />
        <div className="work-title">Mean Guppy</div>
        <div className="work-subtitle">Software Engineer</div>
        <div className="work-duration">2023 - Present</div>

        <div className="work-description">
          <ul className="work-description-list">
            <li>
              Develop front-end components from Figma wireframes, reducing
              development cycles by 15%.
            </li>
            <li>
              Collaborate with local and remote teams using Asana and Azure,
              improving ticket handling.
            </li>
            <li>
              Adhere to security protocols, achieving zero security breaches.
            </li>
            <li>Ensure web applications are ADA accessible.</li>
          </ul>
        </div>
      </div>
      <div className="work-expanded">
      <img src="./boca_code_logo.jpeg" alt="facebook" className="work-image" />
        <div className="work-title">Boca Code</div>
        <div className="work-subtitle">Software Engineer Intern</div>
        <div className="work-duration">2022 - 2022</div>
        <div className="work-description">
          <ul className="work-description-list">
            <li>
              Create a specialized intranet website for Boca Code students,
              engaging with over 25 students weekly.
            </li>
            <li>
              Develop all DOM elements using React and TypeScript, reducing
              development time by 20%.
            </li>
            <li>
              Maintain backend infrastructure on Google Cloud Platform, ensuring
              99.9% uptime.
            </li>
            <li>
              Design three content-rich pages with over 30 components for
              smooth, cached rendering.
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div className="button">
      <a
        href={`${process.env.PUBLIC_URL}/resume.pdf`}
        download="Hugo_Salles.pdf"
        className="download-button"
        onClick={(e) => e.stopPropagation()}
      >
        <text>Download my resume</text>
      </a>
    </div>
  </div>
);
